module.exports = __webpack_public_path__ + "img/Nyromantikk_Spraaket_i_perioden1.edc4cf7c.jpg";